import { environment } from "src/environments/environment";

export class GlobalConstants {
  public static isAuth: boolean;
  public static selectedModal: string;
  public static token: any = localStorage.getItem('accessToken' + environment.connId);
  public static tokenCentral: any = localStorage.getItem('accessTokenCentral' + environment.connId);
  public static language = localStorage.getItem("selectedLangUlazniceNogomet");
  public static headers:any = {
    headers: {
      "Authorization": `Bearer ${GlobalConstants.token}`,
      //"Accept-Language": this.language
    }
  }
  public static headersCentral:any = {
    headers: {
      "Authorization": `Bearer ${GlobalConstants.tokenCentral}`,
      //"Accept-Language": this.language,
      'Content-Type': 'application/json'
    }
  }
  public static headersCentralWihoutContentType:any = {
    headers: {
      "Authorization": `Bearer ${GlobalConstants.tokenCentral}`,
    }
  }
}